import React from 'react';
import './SlideInLeftPanel.css';

const SlideInLeftPanel = ({ isOpen, children }) => {
  return (
    <aside
      className={`slide-in-left-panel ${isOpen ? 'open' : ''}`}
      aria-hidden={!isOpen}
      aria-label="Navigation drawer"
    >
      <div className="slide-in-left-panel-content">
        {children}
      </div>
    </aside>
  );
};

export default SlideInLeftPanel;
